enum CodigoBarras {
    Nenhum = 0,
    CodigoBarra = 1,
    QRCode = 2,
}

export default CodigoBarras;
